module.exports = __webpack_public_path__ + "static/media/Amaterasu.e1471e40.jpg";